<template>
  <div>
    <b-row>
      <b-col>
        <h1 class="font-weight-bolder">
          {{ $t('new', { type: $t('project') }) }}
        </h1>
      </b-col>
    </b-row>
    <b-card
      no-body
      class="overflow-hidden"
    >
      <validation-observer ref="projectValidation">
        <b-row>
          <b-col>
            <b-card-body>
              <b-form @submit.prevent="validateForm()">
                <b-row>
                  <b-col sm="12">
                    <b-form-group :label="$t('projectName')">
                      <validation-provider
                        #default="{ errors }"
                        name="Nombre del proyecto"
                        rules="required"
                      >
                        <b-form-input
                          v-model="project.name"
                          size="lg"
                          class="font-weight-bolder"
                          autocomplete="off"
                          type="text"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col
                    sm="12"
                    lg="6"
                  >
                    <b-form-group label="Folio">
                      <validation-provider
                        #default="{ errors }"
                        name="Folio"
                        rules="required"
                      >
                        <b-form-input
                          v-model="project.folio"
                          size="lg"
                          class="font-weight-bolder"
                          autocomplete="off"
                          type="text"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col sm="12">
                    <b-form-group :label="$t('address')">
                      <gmap-autocomplete
                        ref="googleAddress"
                        class="form-control"
                        @place_changed="updateCenter($event)"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col sm="12">
                    <b-form-group :label="$t('googleAddressUrl')">
                      <validation-provider
                        #default="{ errors }"
                        name="url"
                        rules="required"
                      >
                        <b-form-input
                          v-model="project.google_maps_url"
                          class="font-weight-bolder"
                          autocomplete="off"
                          disabled
                          type="text"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col sm="12">
                    <b-form-group
                      :label="$t('observations')"
                      label-for="observations-textarea"
                      description="Puedes agregar aquí detalles como características del proyecto, quién recibe, responsables, notas especiales o restricciones importantes."
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Observaciones"
                        rules=""
                      >
                        <b-form-textarea
                          id="observations-textarea"
                          v-model.trim="project.observations"
                          placeholder="Ej. Proyecto con acceso restringido, el encargado es Juan Pérez..."
                          rows="4"
                          max-rows="6"
                          :maxlength="1000"
                          class="font-weight-bolder"
                        />
                        <div class="d-flex justify-content-between mt-1">
                          <small class="text-danger">{{ errors[0] }}</small>
                          <small class="text-muted">{{ obsLength }}/1000 {{ $t('characters') || 'caracteres' }}</small>
                        </div>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
                <project-tax-information-selector
                  :customer-id="resolvedCustomerId"
                  v-model="project.tax_information_id"
                />

                <b-row>
                  <b-col class="d-flex justify-content-end">
                    <b-button
                      variant="primary"
                      size="lg"
                      class="px-5"
                      type="submit"
                    >
                      {{ $t('save') }}
                    </b-button>
                  </b-col>
                </b-row>
              </b-form>
            </b-card-body>
          </b-col>
          <b-col>
            <div id="root">
              <gmap-map
                ref="map"
                :center="center"
                :zoom="12"
                style="width: 100%; height: 750px"
                @click="setMarker($event)"
              >
                <!-- TODO add pin -->
                <GmapMarker :position="marker" />
              </gmap-map>
            </div>
          </b-col>
        </b-row>
      </validation-observer>
    </b-card>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ProjectTaxInformationSelector from '@/components/projects/ProjectTaxInformationSelector.vue'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    ProjectTaxInformationSelector,
  },

  data() {
    return {
      project: {
        name: '',
        contact_name: '',
        observations: '',
        address_attributes: {
          state: '',
          country: '',
          city: '',
          street: '',
          ext_number: '',
          postal_code: '',
          lat: '',
          lng: '',
          suburb: '',
          google_maps_url: '',
        },
        tax_information_id: null,
      },
      required,
      center: { lat: 25.6866142, lng: -100.3161126 },
      marker: {},
    }
  },
  computed: {
    ...mapGetters('suppliers', ['suppliers', 'newProviderFiles']),
    resolvedCustomerId() {
      return this.$route.params.customerId || this.project.customer_id || null
    },
  },
  mounted() {
    this.fetchProject(this.$route.params.projectId).then(res => {
      this.project = {
        ...res,
        tax_information_id: res.tax_information_id || res.tax_information?.id || null,
      }
      const query = res.google_maps_url.slice(48)
      const latLng = query.split(',')
      const [lat, lng] = latLng
      this.center = {
        lat: parseFloat(lat),
        lng: parseFloat(lng),
      }
      this.marker = {
        lat: parseFloat(lat),
        lng: parseFloat(lng),
      }
      const address = JSON.parse(JSON.stringify(res.address))
      this.$refs.googleAddress.$el.value = address.formatted_address
    })
  },
  methods: {
    ...mapActions('projects', ['editProject', 'fetchProject']),
    updateCenter(place) {
      this.center = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      }
      // this.marker = {
      //   lat: place.geometry.location.lat(),
      //   lng: place.geometry.location.lng(),
      // }
      this.companyAddress = place
      const address = {
        name: '',
        state: '',
        country: '',
        city: '',
        street: '',
        ext_number: '',
        int_number: '',
        postal_code: '',
        lat: '',
        lng: '',
        suburb: '',
        url: '',
        formatted_address: '',
      }
      place.address_components.forEach(x => {
        if (x.types.includes('administrative_area_level_1')) {
          address.state = x.long_name
        }
        if (x.types.includes('country')) {
          address.country = x.long_name
        }
        if (x.types.includes('city') || x.types.includes('locality')) {
          address.city = x.long_name
        }
        if (x.types.includes('street') || x.types.includes('route')) {
          address.street = x.long_name
        }
        if (
          x.types.includes('ext_number')
          || x.types.includes('street_number')
        ) {
          address.ext_number = x.long_name
        }
        if (x.types.includes('postal_code')) {
          address.postal_code = x.long_name
        }
        if (
          x.types.includes('suburb')
          || x.types.includes('sublocality_level_1')
        ) {
          address.suburb = x.long_name
        }
      })
      address.formatted_address = place.formatted_address
      address.lat = place.geometry.location.lat()
      address.lng = place.geometry.location.lng()
      address.url = place.url
      this.project.address_attributes = address
    },
    setMarker(event) {
      // goecode manual marker to get address address - disabled
      // eslint-disable-next-line
      // const geocoder = new google.gmapApi().maps.Geocoder
      // const latlng = { lat: event.latLng.lat(), lng: event.latLng.lng() }
      // geocoder.prototype.geocode({ location: latlng }, (results, status) => {
      //   if (status === 'OK') {
      //     if (results[1]) {
      //       this.$refs.googleAddress.$el.value = results[1].formatted_address
      //       this.project.address_attributes = this.getAdress(results[1])
      //     } else {
      //       this.$toast({
      //         component: ToastificationContent,
      //         props: {
      //           title: 'Introduzca la direccion manualmente',
      //           icon: 'EditIcon',
      //           variant: 'danger',
      //         },
      //       })
      //     }
      //   }
      // })
      const lat = event.latLng.lat()
      const lng = event.latLng.lng()
      this.project.google_maps_url = `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`
      this.marker = {
        lat,
        lng,
      }
    },
    validateForm() {
      this.$refs.projectValidation.validate().then(success => {
        if (success) {
          this.project.customer_id = this.resolvedCustomerId
          this.editProject({
            ...this.project,
          }).then(response => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$t('projectCreated'),
                icon: 'EditIcon',
                variant: 'success',
              },
            })
            this.$router.push({
              name: 'quotes',
              params: { projectId: response.id },
            })
          })
        }
      })
    },
  },
}
</script>

<style></style>
